import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ThemeProvider } from "next-themes";
import { initErrorReporting, installGlobalErrorHandlers } from "@/lib/errorReporting";
// One-time migration: force light theme for users who never manually chose dark
const THEME_MANUAL_KEY = 'theme-manual-chosen';
if (!localStorage.getItem(THEME_MANUAL_KEY)) {
  localStorage.setItem('theme', 'light');
}

// Production builds must not emit developer debug logs (some include user/review
// payloads). Warnings and errors are kept so real failures stay diagnosable.
if (import.meta.env.PROD) {
  console.log = () => {};
  console.debug = () => {};
}

// Optional error monitoring — no-op unless VITE_SENTRY_DSN is configured.
void initErrorReporting();
installGlobalErrorHandlers();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <App />
    </ThemeProvider>
  </StrictMode>
);
